/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Stats_Total_UsersInputs */

const en_admin_stats_total_users = /** @type {(inputs: Admin_Stats_Total_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Users`)
};

const zh_admin_stats_total_users = /** @type {(inputs: Admin_Stats_Total_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总用户数`)
};

/**
* | output |
* | --- |
* | "Total Users" |
*
* @param {Admin_Stats_Total_UsersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_stats_total_users = /** @type {((inputs?: Admin_Stats_Total_UsersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Stats_Total_UsersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_stats_total_users(inputs)
	return zh_admin_stats_total_users(inputs)
});
export { admin_stats_total_users as "admin.stats.total_users" }